module.exports = __webpack_public_path__ + "img/Car_roof.25f9b0ff.jpg";